import React, { Component } from "react";
import { List } from "../transactions/nfoAndNewPurchase";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import Signbutton, { Debtbutton } from "../../forms/button";
import { Input } from "../../forms/input";
import MenuItem from "@material-ui/core/MenuItem";
import DateFnsUtils from "@date-io/date-fns";
import CustomizedDialogs from "../../home/customModal";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import moment from "moment";

import {
  SUMMARY,
  DETAILED,
  CURRENTFINANCIALYEAR,
  PREVIOUSFINANCIALYEAR,
  SPECIFICPERIOD,
} from "../../../store/types/mailBack";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  ASON,
  BETWEEN,
  SINGLESOA,
  MULTISOA,
} from "../../../store/types/mailBack";
import {
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_LIST_FAILED,
  ALL,
} from "../../../store/types";
import {
  getInvestorDetails,
  getNewPurchaseFundList,
  downloadInvestorProfile,
} from "../../../store/actions";
import {
  getDistFoliobyPan,
  getMailbackSoaStatus,
  // getNewPurchaseFundList
} from "../../../store/actions/mailback";
import {
  Select,
  Checkbox,
  ListItemText,
  Input as MaterialInput,
} from "@material-ui/core";
import { DASHBOARD_URL } from "../dashboard";
import { getCurrentFinancialYearDates,getPreviousFinancialYearDates } from ".";
class MailBackSoa extends Component {
  constructor(props) {
    super(props);
    const reformtStDt = new Date(
      new Date().setFullYear(new Date().getFullYear(), 3, 1)
    ).toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
      day: "2-digit",
    });

    const changeStDt = new Date().toLocaleDateString("en-US", {
      month: "2-digit",
      year: "numeric",
      day: "2-digit",
    });
    const d2 = new Date(reformtStDt).setHours(12, 0, 0, 0);
    const d3 = new Date(changeStDt).setHours(12, 0, 0, 0);
    this.state = {
      summaryData: SUMMARY,
      DetailedData: CURRENTFINANCIALYEAR,
      AsDate: new Date(),
      names: ["sai", "anil", "ravi"],
      selectedNames: [],
      funds: [],
      fund: { value: "189" },
      folios: [],
      folio: { value: "" },
      soaValue: SINGLESOA,
      ConfirmSelfPassword: { value: "Saikota123@" },
      selfPassword: { value: "Saikota123@" },
      open: false,
      showPassword: false,
      confirmShowPassword: false,
      startDate: {
        value:
          d2 > d3
            ? new Date(
                new Date().setFullYear(new Date().getFullYear() - 1, 3, 1)
              )
            : new Date(new Date().setFullYear(new Date().getFullYear(), 3, 1)),
        error: "",
      },
      endDate: { value: new Date(), error: "" },
      schemes: [],
      scheme:{value:""},
      extension: { value: "PDF" },
    };
  }

  async componentDidMount() {
    const params = {
      opt: ALL,
    };
    const types = [
      GET_FUNDS_LIST,
      GET_FUNDS_LIST_SUCCESS,
      GET_FUNDS_LIST_FAILED,
    ];
    this.props.getNewPurchaseFundList(params, types);
    const Folioparams = {
          PAN: this.props.investorData.PAN,
          Fund:"189",
          Agent: this.props.token,
        };
        const response = await this.props.getDistFoliobyPan(Folioparams);
        if (response) {
          this.setState({
            folios: response.DtData.reduce((prev, curr) => {
              const alreadyExist = prev.find((item) => item === curr.acno);
              if (alreadyExist) {
                return prev;
              }
              return [...prev, curr.acno];
            }, []),
          });
        }

    this.setState({
      fund: { value: "189" },
      selfPassword: { value: "" },
      folio: { value: "" },
    });
  }
  changeSoaValue = (event) => () => {
    this.setState({
      soaValue: event,
      selfPassword: { value: "" },
      ConfirmSelfPassword: { value: "" },
    });
  };

  changeDownloadSOAType = (event) => () => {
    this.setState({
      extension: { value: event },
      selfPassword: { value: "" },
      ConfirmSelfPassword: { value: "" },
    });
  }

  handlechange = (event) => {
    const { selectedNames } = this.state;
    const { value } = event.target;
    if (selectedNames.includes(value)) {
      this.setState({
        selectedNames: selectedNames.filter((item) => item !== value),
      });
    } else {
      this.setState({
        selectedNames: [...selectedNames, value],
      });
    }
  };

  
  handleChangefolio = (event) => {
    const folio = event.target.value;
    let schemes = this.schemes(folio);
    
      this.setState({
        folio: { value: folio },
        soaValue: { value: "" },
        selfPassword: { value: "" },
        ConfirmSelfPassword: { value: "" },
      });
    
  };
  schemes = (folio) => { 
    return this.props.fundList.reduce((prev, curr) => {
      if (
        curr.Acno === folio &&
        !!curr.BalUnits
      ) {
        return [...prev, curr];
      }
      return prev;
    }, []);
  };
  handleChangeSelfextractPassWord = (event) => {
    this.setState({
      selfExtract: { value: event.target.value },
    });
  };
  handleChangeConfirmSelfextractPassWord = (event) => {
    this.setState({
      confirmSelfExtract: { value: event.target.value },
    });
  };

  handleChangeSelfPassword = (event) => {
    this.setState({
      selfPassword: { value: event.target.value },
    });
  };
  handleChangeConfirmSelfPassword = (event) => {
    this.setState({
      ConfirmSelfPassword: { value: event.target.value },
    });
  };
  ChangeDetailedData = (event) => () => {
    if (event === PREVIOUSFINANCIALYEAR) {
      const { startDate, endDate } = getPreviousFinancialYearDates();
      this.setState({
        DetailedData: event,
        startDate: { value: startDate },
        endDate: { value: endDate },
        selfPassword: { value: "" },
        ConfirmSelfPassword: { value: "" },
      });
    } else if (event === SPECIFICPERIOD) {
      this.setState({
        DetailedData: event,
        startDate: { value: null },
        endDate: { value: null },
        selfPassword: { value: "" },
        ConfirmSelfPassword: { value: "" },
      });
    } else if (event === CURRENTFINANCIALYEAR) {
      const { startDate, endDate } = getCurrentFinancialYearDates();
      this.setState({
        DetailedData: event,
        startDate: { value: startDate },
        endDate: { value: endDate },
        selfPassword: { value: "" },
        ConfirmSelfPassword: { value: "" },
      });
    }
  };
  changesummaryData = (event) => () => {
    this.setState({
      summaryData: event,
      selfPassword: { value: "" },
      ConfirmSelfPassword: { value: "" },
    });
  };
  download = async () => {
    let startDateValue, endDateValue;
    if (this.state.startDate.value) {
      startDateValue = this.state.startDate.value.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
    if (this.state.endDate.value) {
      endDateValue = this.state.endDate.value.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
    const queryParams = {
      acno: this.state.folio.value.value,
      frmDt:
        this.state.summaryData === SUMMARY
          ?  "01/01/1970" 
          : startDateValue,
      Fund: "189",
      extension: this.state?.extension?.value,
      toDt: this.state.summaryData === SUMMARY ? moment(new Date()).format("DD/MM/YYYY") : endDateValue,
      scheme:this.state.scheme.value.value.Sch,
      plan:this.state.scheme.value.value.Pln,
      option:this.state.scheme.value.value.Opt,
      agent: this.props.token,
      agentname: this.props.userId,
    };
    const response = await this.props.downloadInvestorProfile(queryParams);
    if (!!response && response?.Table2[0]?.Fdata) {
      window.open(`${response.Table2[0].Fdata}`);
    } else  {
      alert(`${response.error}`);
    }
  };
  submit = async () => {
    const {
      selectedNames,
      folios,
      soaValue,
      funds,
      fund,
      folio,
      showPassword,
      confirmShowPassword,
      names,
      open,
      startDate,
      endDate,
      summaryData,
      DetailedData,
      AsDate,
      schemes,
      ...others
    } = this.state;
    let asDateValue, startDateValue, endDateValue;
    if (this.state.AsDate.value) {
      asDateValue = this.state.AsDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "numeric",
      });
    }
    if (this.state.startDate.value) {
      startDateValue = this.state.startDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "numeric",
      });
    }
    if (this.state.endDate.value) {
      endDateValue = this.state.endDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "numeric",
      });
    }
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${
                key === "selfPassword"
                  ? "Self-Password"
                  : key === "ConfirmSelfPassword"
                  ? "Confirm Self-Password"
                  : ""
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "fund": {
          this.fundField.focus();
          break;
        }
      }
    } else if (this.state.selectedNames === []) {
      this.setState({
        password: {
          ...others["folio"],
          isError: true,
        },
      });
      return;
    } else if (
      others.selfPassword.value === "" ||
      others.selfPassword.value !== others.ConfirmSelfPassword.value
    ) {
      if (others.selfPassword.value === "") {
        this.setState({
          password: {
            ...others["selfPassword"],
            isError: true,
            errorMessage: `password is mandatory`,
          },
        });
        return;
      }
    } else if (others.selfPassword.value !== others.ConfirmSelfPassword.value) {
      this.setState({
        password: {
          ...others["ConfirmSelfPassword"],
          isError: true,
          errorMessage: `password Mismatch`,
        },
      });
      return;
    } else if (others.ConfirmSelfPassword.value === "") {
      this.setState({
        password: {
          ...others["ConfirmSelfPassword"],
          isError: true,
          errorMessage: `password is mandatory`,
        },
      });
      return;
    } else {
      const params = {
        UserId: this.props.userId,
        Zippwd: this.state.selfPassword.value,
        RepType: "SOA",
        extension: this.state.extension?.value,
        Arn: this.props.token,
        Pan: this.props.investorData.PAN,
        Acno: this.state.selectedNames.join(),
        Freq: this.state.soaValue === SINGLESOA ? "S" : "M",
        Fund: "189",
        stdt:
          this.state.summaryData === SUMMARY
            ? moment(new Date()).format("MM/DD/YYYY")
            : endDateValue,
        EndDt:
          this.state.summaryData === SUMMARY ? "01/01/1970" : startDateValue,
      };
      const response = await this.props.getMailbackSoaStatus(params);
      if (response) {
        this.setState({
          open: true,
        });
      }
    }
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "selfPassword") {
      if (
        this.state.selfPassword.value === "" ||
        !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          this.state.selfPassword.value
        )
      ) {
        if (
          !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
            this.state.selfPassword.value
          )
        ) {
          this.setState({
            selfPassword: {
              value: this.state.selfPassword.value,
              isError: true,
              errorMessage: `Password should be at least 8 characters in length and should contain at least 1 Upper Case alphabet(A-Z).1 Special Character and 1 Numeric Value (0-9)`,
            },
          });
          return;
        }
      } else if (this.state.selfPassword.value === "") {
        this.setState({
          selfPassword: {
            value: "",
            isError: true,
            errorMessage: `Password is mandatory`,
          },
        });
        return;
      }
    } else if (label === "ConfirmSelfPassword") {
      this.setState({
        [label]: {
          value,
          isError:
            this.state.selfPassword.value !==
              this.state.ConfirmSelfPassword.value ||
            this.state.ConfirmSelfPassword.value === ""
              ? true
              : !value,
          errorMessage:
            this.state.selfPassword.value !==
              this.state.ConfirmSelfPassword.value ||
            this.state.ConfirmSelfPassword.value === ""
              ? `The Password and Confirm Password do not match`
              : "",
        },
      });
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };

  closeModal = () => {
    this.setState({
      open: false,
    });
    this.props.history.replace(DASHBOARD_URL);
  };
  onDateChange = (label, event) => {
    if (label === "endDate" && !!this.state.startDate.value && !!event) {
      const reformtStDt = this.state.startDate.value.toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          year: "numeric",
          day: "2-digit",
        }
      );

      const changeEndDt = event.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });

      const d2 = new Date(reformtStDt).setHours(12, 0, 0, 0);
      const d3 = new Date(changeEndDt).setHours(12, 0, 0, 0);
      if (d2 > d3 || d2 === d3) {
        this.setState({
          [label]: {
            value: null,
            error: true,
            errorMessage: "Start Date should be earlier than End Date",
          },
        });
      } else {
        this.setState({
          [label]: { value: event, errorMessage: "", error: false },
        });
      }
    } else if (label === "startDate") {
      this.setState({
        [label]: { value: event },
        endDate: { value: null, error: "", errorMessage: "" },
      });
    }
    // this.setState({ [label]: { value: event } });
  };
  handleFolioChange = async (value) => {
    const folio = !!value ? value.value : "";
      let schemes = this.schemes(folio);
      this.setState({
        folio:{value:value},
        schemes:schemes,
      })
    }
    handleSchemeChange = (value) => {
      this.setState({
        scheme: { value },
      });
    };
  render() {
    const { investorData, fundsList } = this.props;
    const {
      selectedNames,
      DateON,
      summaryData,
      DetailedData,
      fund,
      folios,
      soaValue,
      ConfirmSelfPassword,
      selfPassword,
      folio,
      schemes,
      scheme,
      extension
    } = this.state;
    return (
      <div className="container-margin" style={{ marginTop: 20 }}>
        <Paper
          className="digital-form-container"
          style={{ boxShadow: "0px 0px 2px 0px lightgray" }}
        >
          <div className="digital-form-left-div">
            <List investorData={investorData} />
          </div>

          <div className="digital-form-Right-div">
            <div className="transaction-details">
              <div className="title">SOA</div>
              <div className="radio-buttons-div">
                <Debtbutton
                  buttontitle="Summary"
                  width={150}
                  active={summaryData === SUMMARY}
                  onClick={this.changesummaryData(SUMMARY)}
                />
                <Debtbutton
                  buttontitle="Detailed"
                  width={150}
                  active={summaryData === DETAILED}
                  onClick={this.changesummaryData(DETAILED)}
                />
              </div>
              {summaryData === SUMMARY ? (
                <div>
                  <div className="input-name ">As on Date</div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      required={true}
                      className="selects"
                      onChange={(e) => this.onDateChange("AsDate", e)}
                      // openTo={true}
                      disabled={true}
                      disableFuture={true}
                      format="dd/MM/yyyy"
                      // minDate={new Date(new Date().setFullYear(1980, 0, 1))}
                      maxDate={new Date()}
                      margin="normal"
                      // animateYearScrolling={true}
                      id="mui-pickers-date"
                      value={this.state.AsDate}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              ) : (
                <div>
                  <div className="input-name">Detailed Options</div>
                  <div className="radio-buttons-div">
                    <Debtbutton
                      buttontitle="Current Financial Year"
                      width={200}
                      active={DetailedData === CURRENTFINANCIALYEAR}
                      onClick={this.ChangeDetailedData(CURRENTFINANCIALYEAR)}
                    />
                    <Debtbutton
                      buttontitle="Previous Financial Year"
                      width={200}
                      active={DetailedData === PREVIOUSFINANCIALYEAR}
                      onClick={this.ChangeDetailedData(PREVIOUSFINANCIALYEAR)}
                    />
                    <Debtbutton
                      buttontitle="Specific Period"
                      width={200}
                      active={DetailedData === SPECIFICPERIOD}
                      onClick={this.ChangeDetailedData(SPECIFICPERIOD)}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <div className="input-name">Start Date</div>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      style={{ width: "100%" }}
                    >
                      <KeyboardDatePicker
                        required={true}
                        className="selects"
                        onChange={(e) => this.onDateChange("startDate", e)}
                        // openTo={true}
                        disableFuture={true}
                        format="dd/MM/yyyy"
                        disabled={
                          DetailedData === SPECIFICPERIOD ? false : true
                        }
                        minDate={
                          DetailedData === CURRENTFINANCIALYEAR
                            ? getCurrentFinancialYearDates().startDate
                            : DetailedData === PREVIOUSFINANCIALYEAR
                            ? getPreviousFinancialYearDates().startDate
                            : new Date(1970, 0, 1)
                        }
                        style={{
                          marginTop: 0,
                          marginBottom: 10,
                        }}
                        maxDate={new Date()}
                        margin="normal"
                        // animateYearScrolling={true}
                        id="mui-pickers-date"
                        value={this.state.startDate.value}
                      />
                    </MuiPickersUtilsProvider>
                    <div className="input-margin">
                      <div className="input-field-container input-name">
                        End Date
                      </div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          required={true}
                          className="selects"
                          onChange={(e) => this.onDateChange("endDate", e)}
                          disableFuture={true}
                          disabled={
                            DetailedData === SPECIFICPERIOD &&
                            !!this.state.startDate.value
                              ? false
                              : true
                          }
                          format="dd/MM/yyyy"
                          maxDate={
                            DetailedData === CURRENTFINANCIALYEAR
                              ? getCurrentFinancialYearDates().endDate
                              : DetailedData === PREVIOUSFINANCIALYEAR
                              ? getPreviousFinancialYearDates().endDate
                              : new Date()
                          }
                          value={this.state.endDate.value}
                          id="mui-pickers-date"
                          errorMessage={this.state.endDate.errorMessage}
                        />
                      </MuiPickersUtilsProvider>
                      {!!this.state.endDate.errorMessage ? (
                        <div
                          style={{
                            color: "red",
                            fontFamily: "OpenSans-Italic",
                          }}
                        >
                          {this.state.endDate.errorMessage}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}
              
        <div className="input-margin">
          <div className="input-name input-integrated-label">Folio</div>
          <IntegrationReactSelect
            suggestions={folios.map((item) => ({
              label: item,
              value: item,
            }))}
            value={folio.value}
            placeholder="Select Folio"
            handleChange={this.handleFolioChange}
            inputRef={(ele) => (this.folioField = ele)}
            isError={folio.isError}
            errorMessage={folio.errorMessage}
          />
        </div>
        <div className="input-name">
          <div className="input-name input-integrated-label">Scheme</div>
          <IntegrationReactSelect
            suggestions={schemes.map((item) => ({
              label: item.PlnDesc
                ? `${item.SchDesc1} - ${item.PlnDesc} - ${item.OptDesc}`
                : item.fm_schdesc,
              value: item,
            }))}
            value={scheme.value}
            placeholder="Select Scheme"
            handleChange={this.handleSchemeChange}
            inputRef={(ele) => (this.schemeField = ele)}
            isError={scheme.isError}
            disabled={!folio.value}
            errorMessage={scheme.errorMessage}
          />
        </div>
              <div>
                <div className="input-name">Extension Type</div>
                <div className="radio-buttons-div">
                  <Debtbutton
                    buttontitle="PDF"
                    width={150}
                    active={extension.value === "PDF"}
                    onClick={this.changeDownloadSOAType("PDF")}
                  />
                  <Debtbutton
                    buttontitle="Excel"
                    width={150}
                    active={extension.value === "EXCEL"}
                    onClick={this.changeDownloadSOAType("EXCEL")}
                  />
                </div>
              </div>
              <Signbutton buttontitle="Download" onClick={this.download} />

              <div className="input-margin">
                <Input
                  name="Self Extraction Password"
                  onChange={this.handleChangeSelfPassword}
                  value={selfPassword.value}
                  image2={
                    !!this.state.showPassword
                      ? "/images/eye@3x.png"
                      : "/images/password_visible.png"
                  }
                  type={!!this.state.showPassword ? "text" : "password"}
                  height={15}
                  onClick={() =>
                    this.setState({
                      showPassword: !this.state.showPassword,
                    })
                  }
                  onBlur={this.showError("selfPassword")}
                  isShowError={selfPassword.isError}
                  errorMessage={selfPassword.errorMessage}
                  bordercolor="#a6a6a6"
                  inputref={(ele) => (this.selfPasswordField = ele)}
                />
              </div>
              <div className="input-margin">
                <Input
                  name="Confirm Self Extraction Password"
                  image2={
                    !!this.state.confirmShowPassword
                      ? "/images/eye@3x.png"
                      : "/images/password_visible.png"
                  }
                  onClick={() =>
                    this.setState({
                      confirmShowPassword: !this.state.confirmShowPassword,
                    })
                  }
                  type={!!this.state.confirmShowPassword ? "text" : "password"}
                  height={15}
                  onChange={this.handleChangeConfirmSelfPassword}
                  value={ConfirmSelfPassword.value}
                  onBlur={this.showError("ConfirmSelfPassword")}
                  isShowError={ConfirmSelfPassword.isError}
                  errorMessage={ConfirmSelfPassword.errorMessage}
                  bordercolor="#a6a6a6"
                  inputref={(ele) => (this.ConfirmSelfPasswordField = ele)}
                />
              </div>
              <div className="digital-form-button-next-div">
                <Signbutton buttontitle="Submit" onClick={this.submit} />
              </div>
              <CustomizedDialogs
                cas={true}
                open={this.state.open}
                closeYesModal={this.closeModal}
                // componentName="MailBackSoa"
              />
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const { investorData, userId, token,fundList } = authReducer;
    const { fundsList } = transactions;
    return { investorData, userId, token, fundsList,fundList };
  },
  {
    getInvestorDetails,
    getNewPurchaseFundList,
    getDistFoliobyPan,
    getMailbackSoaStatus,
    downloadInvestorProfile,
  }
)(MailBackSoa);
